module.exports = __webpack_public_path__ + "static/media/logo-medium.1b132a4f.png";